import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 * 
 * @param {*} id 
 * 
 
 * 
 * @returns { categories, loading, error };
 */
function useCategories() {
  const [categories, setCategories] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const categories = await dataProvider.getList("product-categories", {});
        setCategories(categories.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { categories, loading, error };
}

export default useCategories;
